import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_roots-32-learners/artifacts/uy0bpy4k_ChatGPT%20Image%20May%204%2C%202026%2C%2008_01_42%20PM.png";

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'The Model', path: '/model' },
  { name: 'Academics', path: '/academics' },
  { name: 'Admissions', path: '/admissions' },
  { name: 'Summer Camp', path: '/summer-camp' },
  { name: 'FAQ', path: '/faq' },
];

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isHomePage = location.pathname === '/';
  
  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-[#F9F8F4]/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="container-nova">
        <nav className="flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
<Link to="/" className="flex items-center gap-3" data-testid="logo-link">
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    <img 
      src="/logo.png"
      alt="Nova Roots Logo" 
      className={`h-12 md:h-14 w-auto object-contain transition-all duration-300 ${
        isHomePage && !isScrolled ? 'brightness-0 invert' : ''
      }`}
    />
    <div className={`transition-all duration-300 ${
      isHomePage && !isScrolled ? 'text-white' : 'text-[#1A3C34]'
    }`}>
      <h1 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>Nova Roots</h1>
      <p style={{ margin: 0, fontSize: '10px', opacity: 0.8 }}>Learning Hub</p>
    </div>
  </div>
</Link>
          {/* <Link to="/" className="flex items-center" data-testid="logo-link">
            <img 
              src="/logo.png" 
              alt="Nova Roots Schools" 
              className={`h-16 md:h-20 w-auto object-contain transition-all duration-300 ${
                isHomePage && !isScrolled ? 'brightness-0 invert' : ''
              }`}
            />
          </Link> */}

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                className={`text-sm tracking-wide transition-colors duration-300 ${
                  location.pathname === link.path 
                    ? (isHomePage && !isScrolled ? 'text-white font-medium' : 'text-[#1A3C34] font-medium')
                    : (isHomePage && !isScrolled ? 'text-white/90 hover:text-white' : 'text-[#5C6B6B] hover:text-[#1A3C34]')
                }`}
              >
                {link.name}
              </Link>
            ))}
            {/* Summer Camp CTA Button */}
            <Link
              to="/summer-camp"
              data-testid="nav-summer-camp-cta"
              className={`px-5 py-2.5 rounded-full text-sm font-medium tracking-wide transition-all duration-300 ${
                isHomePage && !isScrolled 
                  ? 'bg-[#C27856] text-white hover:bg-[#A8654A]' 
                  : 'bg-[#C27856] text-white hover:bg-[#A8654A]'
              }`}
            >
              Summer Camp
            </Link>
          </div>

        {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-button"
            className={`lg:hidden p-2 transition-colors duration-300 ${
              isHomePage && !isScrolled ? 'text-white' : 'text-[#1A3C34]'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div 
            data-testid="mobile-menu"
            className="lg:hidden absolute top-full left-0 right-0 bg-[#F9F8F4] border-t border-[#EBE8E0] shadow-lg"
          >
            <nav className="container-nova py-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  className={`py-3 text-base tracking-wide transition-colors ${
                    location.pathname === link.path 
                      ? 'text-[#1A3C34] font-medium' 
                      : 'text-[#5C6B6B] hover:text-[#1A3C34]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              {/* Summer Camp CTA in Mobile */}
              <Link
                to="/summer-camp"
                data-testid="mobile-nav-summer-camp-cta"
                className="mt-2 py-3 px-6 bg-[#C27856] text-white text-center rounded-full font-medium tracking-wide hover:bg-[#A8654A] transition-colors"
              >
                Summer Camp
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
